export const defaultErrorMessage = 'Něco se pokazilo. Zkuste to znovu později.';
